var map = {
	"./_images/admin-holiday-list-part-day.png": 4052,
	"./_images/admin-support-access-give.png": 5250,
	"./_images/office-incident-log-pick-shift.png": 3035,
	"./_images/office-merge-participants-shared-contact.png": 4263,
	"./_images/office-shift-notes-export-window.png": 3495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6659;